import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';
import qs from 'qs';
import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';

const routes = {
  laneRatesPath: () => '/api/LaneRate/',
  laneRatesPathById: (id) => `${routes.laneRatesPath()}${id}`,
  laneRatesGridPath: () => `${routes.laneRatesPath()}Grid`,
  laneRatesRatesPath: (laneRateId) => `${routes.laneRatesPath()}${laneRateId}/Rates`,
  laneRateRatesPathById: (laneRateId, id) => `${routes.laneRatesPath()}${laneRateId}/Rates/${id}`,
  laneRatesDeliveryTypesPath: () => `${routes.laneRatesPath()}DeliveryTypes`,
  laneRatesRateTypesPath: () => `${routes.laneRatesPath()}RateTypes`,
  laneRatesPointTypesPath: () => `${routes.laneRatesPath()}PointTypes`,
  laneRatesCurrentDriverPayPath: (id) => `${routes.laneRatesPath()}CurrentDriverPayById?laneRateId=${id}`,
  laneRatesAuditsPathById: (id, params) => `${routes.laneRatesPath()}${id}/Audits${getQueryParams(params)}`,
  laneRatesAuditPropertiesPathById: (id) => `${routes.laneRatesPath()}${id}/Audits/Properties`,
  laneRatesAuditUsersPathById: (id) => `${routes.laneRatesPath()}${id}/Audits/Users`,
  restoreLaneRatesPathById: (id) => `${routes.laneRatesPath()}${id}/restore`,
  bulkChangePath: () => '/api/LaneRate/changeall',
  bulkChangeValidatePath: () => '/api/LaneRate/changeall/validate',
  bulkChangeAssignPath: () => '/api/LaneRate/changeall/assign',
};

export const getLaneRatesGrid = async (params) => {
  const query = params && Object.keys(params).length > 0 ? `?${qs.stringify(params, { indices: false })}` : '';
  return makeRequest(authFetch.get(`${routes.laneRatesGridPath()}${query}`));
};

export const getLaneRates = (params) => makeRequest(authFetch.get(`/api/LaneRate/grid${getQueryParams(params)}`));

export const getLaneRatesById = (id) => makeRequest(authFetch.get(routes.laneRatesPathById(id)));

export const deleteLaneRates = (id) => makeRequest(authFetch.delete(routes.laneRatesPathById(id)));

export const restoreLaneRates = (id) => makeRequest(authFetch.patch(routes.restoreLaneRatesPathById(id)));

export const getLaneRateAudits = (id, params) => makeRequest(authFetch.get(routes.laneRatesAuditsPathById(id, params)));

export const getLaneRateAuditProperties = (id) =>
  makeRequest(authFetch.get(routes.laneRatesAuditPropertiesPathById(id)));

export const getLaneRateAuditUsers = (id) => makeRequest(authFetch.get(routes.laneRatesAuditUsersPathById(id)));

export const upsertLaneRate = (data) => makeRequest(authFetch.put(`${routes.laneRatesPath()}`, data));

export const getDriverPayForLane = (id) => makeRequest(authFetch.get(routes.laneRatesCurrentDriverPayPath(id)));

export const getDeliveryTypes = () => makeRequest(authFetch.get(routes.laneRatesDeliveryTypesPath()));

export const getLaneRateRateTypes = () => makeRequest(authFetch.get(routes.laneRatesRateTypesPath()));

export const getPointTypes = () => makeRequest(authFetch.get(routes.laneRatesPointTypesPath()));

export const getLaneRateRates = (laneRateId) => makeRequest(authFetch.get(routes.laneRatesRatesPath(laneRateId)));

export const upsertLaneRateRates = (laneRateId, data) =>
  makeRequest(authFetch.put(`${routes.laneRatesRatesPath(laneRateId)}`, data));

export const deleteLaneRateRates = (laneRateId, id) =>
  makeRequest(authFetch.delete(routes.laneRateRatesPathById(laneRateId, id)));

// Bulk Change
export const changeAllValidate = (data) => makeRequest(authFetch.patch(routes.bulkChangeValidatePath(), data));

export const changeAllAssign = (data) => makeRequest(authFetch.patch(routes.bulkChangeAssignPath(), data));

export const useLaneRatesGrid = (params) => {
  return useQuery({
    queryKey: ['laneRates', params],
    queryFn: () => getLaneRatesGrid(params),
    keepPreviousData: true,
  });
};

export const useDeliveryTypes = () => {
  return useQuery({
    queryKey: ['deliveryTypes'],
    queryFn: getDeliveryTypes,
    ...CacheConfig.forever
  });
};

export const useRateTypes = () => {
  return useQuery({
    queryKey: ['rateTypes'],
    queryFn: getLaneRateRateTypes,
    ...CacheConfig.forever
  });
};

export const useGetPointTypes = () => {
  return useQuery({
    queryKey: ['pointTypes'],
    queryFn: getPointTypes,
    ...CacheConfig.forever
  });
};